// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1fNyt","avatar":"style_avatar__7-io1","menuIcon":"style_menuIcon__P9mJI"};